// Port of api/fuel/app/classes/filter/package/games/game/prepare/owners.php
import Constants from 'offline/constants'
import Enum from 'offline/enum'
import F from 'offline/filter/constants'

// Hoist the status field iteration out of every per-row run() call.
// Each entry pairs a status field name with its column name and the
// constant that indicates which special-case bucket the status belongs to.
var STATUS_FIELDS = (function() {
	var keys = Object.keys(Enum.collection_status_field)
	var entries = new Array(keys.length)
	for (var i = 0; i < keys.length; i++) {
		var statusField = keys[i]
		entries[i] = {
			statusField: statusField,
			column: Enum.collection_status_field[statusField],
			constant: Enum.collection_status_constant[statusField]
		}
	}
	return entries
})()

var STATUS_HASPARTS = Constants.COLLECTION_STATUS_HASPARTS
var STATUS_WANTPARTS = Constants.COLLECTION_STATUS_WANTPARTS
var STATUS_WISHLIST = Constants.COLLECTION_STATUS_WISHLIST
var BR_RE = /\n/g
var BR = '<br />'

export default {
	priority: 20,
	run: function(local, global) {
		local.versions = { game: {}, user: false }
		local.parts = { game: [], user: [] }
		local.wishlist = { game: [], user: [] }
		var ownerKey = global.ownerGroup || 'game_id'
		var lookupId = (ownerKey === 'collection_id') ? local.id : local.game_id
		var owners = global.owners ? global.owners[lookupId] : null
		if (!owners || !owners.length) return local

		var ownerTypeIsUser = global.ownerType === F.OWNER_USER
		var globalUserID = global.userID
		var localStatus = local.status
		var localStatusGame = localStatus && localStatus.game
		var localStatusUser = localStatus && localStatus.user
		var partsGame = local.parts.game
		var partsUser = local.parts.user
		var wishlistGame = local.wishlist.game
		var versionsGame = local.versions.game
		var statusFieldsLen = STATUS_FIELDS.length

		for (var i = 0; i < owners.length; i++) {
			var o = owners[i]
			var uid = o.user_id | 0
			var versionId = o.game_version_id | 0
			var isCurrentUser = uid === globalUserID || ownerTypeIsUser

			for (var s = 0; s < statusFieldsLen; s++) {
				var entry = STATUS_FIELDS[s]
				if (!o[entry.column]) continue

				var statusField = entry.statusField

				if (localStatusGame && localStatusGame[statusField] && localStatusGame[statusField].indexOf(uid) === -1) {
					localStatusGame[statusField].push(uid)
				}

				if (isCurrentUser) {
					if (localStatusUser) localStatusUser[statusField] = 1
					local.versions.user = versionId
				}

				versionsGame[uid] = versionId

				var statusConstant = entry.constant

				if (statusConstant === STATUS_HASPARTS || statusConstant === STATUS_WANTPARTS) {
					var partsText = String(o[entry.column + '_text'] || '').replace(BR_RE, BR)
					partsGame.push({
						user: uid,
						ownerType: statusConstant,
						text: partsText
					})

					if (isCurrentUser) {
						partsUser.push({
							ownerType: statusConstant,
							text: partsText
						})
					}
				}

				if (statusConstant === STATUS_WISHLIST) {
					var wishPriority = o.collection_wishlist_priority | 0
					var wishText = String(o.collection_wishlist_comment || '').replace(BR_RE, BR)
					wishlistGame.push({
						user: uid,
						priority: wishPriority,
						text: wishText
					})

					if (isCurrentUser) {
						local.wishlist.user = {
							priority: wishPriority,
							text: wishText
						}
					}
				}
			}
		}
		return local
	}
}
